import React, { useEffect } from "react";
import Banner from "../../components/UserSideComponents/common/Banner";
import Bannerimg from "../../Assets/banner.png";
import img1 from "../../Assets/corporate/img-1.png";
import img2 from "../../Assets/corporate/img-2.png";

const Corporate = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Banner image={Bannerimg} heading={"Corporate"} />
      <div className="px-4 sm:px-6 md:px-10 py-10 min-h-screen bg-yellow-50/30">
        <div className="flex flex-col items-center justify-center text-center mb-10">
          <p className="text-[#92AD36] text-sm font-semibold tracking-widest uppercase">
            Corporate Section
          </p>
          <h2 className="text-2xl md:text-4xl font-serif  text-black mt-3">
            Our Corporate Record
          </h2>
          <div className="flex mt-4 gap-2">
            <span className="w-10 h-1 bg-[#92AD36]" />
            <span className="w-3 h-1 bg-[#92AD36]" />
            <span className="w-5 h-1 bg-[#92AD36]" />
          </div>
        </div>
        <div className="flex flex-col">
          <div>
            <span className="text-black font-serif text-3xl ">Objectives</span>
            <p className="text-black text-base tracking-wide  mt-4 leading-7">
              At Kalinga-BIo, our dedication to fostering sustainable
              agriculture has led to the establishment of a cutting-edge
              Research and Development Unit. Officially inaugurated on June 22,
              2023, in Peenya, Bangalore, this facility is designed to address
              the growing concerns of modern agriculture. We define our R&D
              activities as an important means for achieving the future growth
              of Bio-Agri by developing relevant products in the market. Our
              primary objectives to design and develop some technology/product
              to address the issues, which includes:
            </p>
            <ul className="list-disc list-inside space-y-5 text-sm text-black tracking-wide mt-6">
              <li>
                Strengthening bio-intensive agriculture to minimize chemical
                utilization.
              </li>
              <li>Improving crop tolerance towards changing climate.</li>
              <li>Minimizing post-harvest losses</li>
              <li>
                Fertilizers supply essential nutrients like nitrogen,
                phosphorus, and potassium that help plants grow faster and
                healthier.
              </li>
              <li>
                Using fertilizers increases soil fertility, which leads to
                higher agricultural production and better quality crops.
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mt-10">
          <img src={img1} alt="" className="w-full rounded-xl" />
          <img src={img2} alt="" className="w-full rounded-xl" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mt-10">
          <div className="flex flex-col">
            <div>
              <span className="text-black font-serif text-3xl">Features</span>
              <p className="text-black text-base tracking-wide  mt-4 leading-7">
                These laboratories represent a comprehensive and integrated
                approach to advancing agricultural science through innovation
                and research. Each lab is dedicated to a specific domain,
                ranging from microbiology and entomology to chemical synthesis
                and formulation development. Together, they work to explore
                sustainable, efficient, and environmentally friendly solutions
                for modern agriculture.
              </p>
              <ul className="list-disc list-inside space-y-5 text-sm text-black tracking-wide mt-6">
                <li>
                  <strong>Microbiology Lab:</strong> Conducts in-depth basic and
                  applied research to explore the potential of the microbial
                  world in agriculture and its biological aspects.
                </li>

                <li>
                  <strong>Entomology Lab:</strong> Focuses on insect-related
                  issues in crop production and manages them by developing
                  environmentally friendly technologies.
                </li>

                <li>
                  <strong>Biochemistry Lab:</strong> Explores the potential of
                  safer chemical molecules for agricultural use.
                </li>

                <li>
                  <strong>Instrumentation Lab:</strong> Used for advanced and
                  innovative research activities.
                </li>

                <li>
                  <strong>Formulation Lab:</strong> Develops innovative
                  agricultural formulations.
                </li>
              </ul>
            </div>
          </div>
          <img src={img1} alt="" className="w-full rounded-xl" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mt-10">
          <div className="flex flex-col md:order-2">
            <div>
              <span className="text-black font-serif text-3xl">Facilities</span>
              <p className="text-black text-base tracking-wide  mt-4 leading-7">
                Our facilities are designed to support advanced agricultural
                research and innovation with a strong focus on efficiency,
                precision, and sustainability. Equipped with modern
                infrastructure and cutting-edge technology, these facilities
                enable scientists and researchers to conduct experiments,
                develop new solutions, and ensure high-quality outcomes.
              </p>
              <ul className="list-disc list-inside space-y-5 text-sm text-black tracking-wide mt-6">
                <li>
                  <strong>Research Infrastructure:</strong> State-of-the-art
                  laboratories equipped for advanced scientific studies.
                </li>

                <li>
                  <strong>Modern Equipment:</strong> Access to high-end
                  instruments for accurate testing and analysis.
                </li>

                <li>
                  <strong>Pilot Production Units:</strong> Facilities for
                  small-scale production and testing of formulations.
                </li>

                <li>
                  <strong>Storage Facilities:</strong> Safe and controlled
                  storage systems for chemicals and biological materials.
                </li>

                <li>
                  <strong>Quality Assurance Systems:</strong> Dedicated setups
                  to maintain product quality and compliance.
                </li>

                <li>
                  <strong>Sustainability Measures:</strong> Eco-friendly systems
                  to minimize environmental impact.
                </li>
              </ul>
            </div>
          </div>
          <img src={img1} alt="" className="w-full rounded-xl md:order-1" />
        </div>

        <div className="flex flex-col items-center justify-center mt-10">
          <h3 className="text-3xl font-serif  mb-4">Future Goals</h3>
          <p className="text-base leading-7 text-center sm:w-1/2 mb-5">
            We aim to expand our research capabilities and develop
            next-generation agricultural solutions that are sustainable,
            efficient, and globally competitive.
          </p>

          <ul className="list-disc list-inside space-y-3 text-sm">
            <li>Develop eco-friendly bio-products.</li>
            <li>Expand global market reach.</li>
            <li>Invest in advanced R&D technologies.</li>
            <li>Promote sustainable farming practices.</li>
            <li>Strengthen farmer support systems.</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Corporate;
